"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
exports.__esModule = true;
var basic_chart_component_1 = require("../basic-component/basic-chart.component");
function makeLine(data, color, zIndex, isStartInMainSeriesData, dashStyleIndex) {
    if (isStartInMainSeriesData === void 0) { isStartInMainSeriesData = null; }
    if (dashStyleIndex === void 0) { dashStyleIndex = 0; }
    var dashStyles = basic_chart_component_1.getDashStyles();
    return {
        id: '',
        enableMouseTracking: false,
        showInLegend: false,
        type: 'line',
        color: color,
        zIndex: zIndex,
        marker: {
            enabled: false
        },
        linkedTo: ':previous',
        data: isStartInMainSeriesData ? data : [[0, 0]].concat(data),
        dashStyle: dashStyles[dashStyleIndex]
    };
}
function makeStartPointSeries() {
    return {
        showInLegend: false,
        zIndex: 6,
        data: [{ name: 'Start', x: 0, y: 0, ax: 0, ay: 0, color: '#C0C0C0' }]
    };
}
function processDrillDownSeries(series) {
    return __assign({}, series, { type: 'line', marker: {
            enabled: true,
            radius: 5,
            symbol: 'circle'
        }, data: [{ name: 'Start', x: 0, y: 0, ax: 0, ay: 0, color: '#C0C0C0' }].concat(series.data) });
}
function generateSeries(dataRows, legends, zindex, filter) {
    if (zindex === void 0) { zindex = 6; }
    if (filter === void 0) { filter = true; }
    var series = [];
    var _loop_1 = function (legend) {
        var tagKey = legend['tag'];
        var tagColor = legend['color'];
        var seriesData = dataRows;
        if (filter) {
            seriesData = dataRows.filter(function (item) {
                return item.colorTag === tagKey && typeof item.y !== 'undefined';
            });
        }
        if (seriesData.length > 0) {
            var s = {
                'name': tagKey,
                'color': tagColor,
                'zIndex': zindex,
                'data': seriesData
            };
            if (tagColor == 'red' && 'symbol' in legend && legend['symbol'] == 'cross') {
                s['legendIndex'] = 50;
                s['marker'] = {
                    'symbol': 'cross',
                    'lineWidth': 4,
                    'lineColor': 'red',
                    'states': {
                        'hover': {
                            'lineColor': 'red',
                            'lineWidth': 4
                        }
                    }
                };
            }
            series.push(s);
        }
    };
    for (var _i = 0, legends_1 = legends; _i < legends_1.length; _i++) {
        var legend = legends_1[_i];
        _loop_1(legend);
    }
    return series;
}
function setValuesForStart(mainSeriesData, i, legends) {
    mainSeriesData[i]['x'] = mainSeriesData[i]['cumulativeCost'];
    mainSeriesData[i]['y'] = mainSeriesData[i]['cumulativeValue'];
    mainSeriesData[i]['ax'] = 0;
    mainSeriesData[i]['ay'] = 0;
    mainSeriesData[i]['colorTag'] = legends[0]['tag'];
    // mainSeriesData[i]['color'] = legends[0]['color'];
}
function checkAndSetStartInMainSeriesData(mainSeriesData, legends) {
    for (var i = 0; i < mainSeriesData.length; i++) {
        if (mainSeriesData[i].name === "Start") {
            setValuesForStart(mainSeriesData, i, legends);
            return true;
        }
    }
    return false;
}
function updateLegendsForCancelledProjects(seriesData, legends, compareTo) {
    if (compareTo === void 0) { compareTo = false; }
    var cancelledTag = compareTo ? 'Cancelled Projects (Compare)' : 'Cancelled Projects';
    seriesData.forEach(function (row) {
        if ('marker' in row && row['marker']['symbol'] == 'cross') {
            row['colorTag'] = cancelledTag;
            if (!(legends.find(function (l) { return l.color === 'red'; }))) {
                legends.unshift({ 'color': 'red', 'tag': cancelledTag, 'symbol': 'cross' });
            }
        }
    });
}
function getChartOptions(graph, options) {
    var currentNode = options.currentNode, chartTitle = options.chartTitle, _a = options.legends, legends = _a.legends, siblingLegends = _a.siblingLegends, settings = options.settings, timestamp = options.timestamp;
    var nodeName = currentNode.name;
    var mainSeriesData = graph.mainRows.sort(function (a, b) { return a.x - b.x; });
    var siblingSeriesData = (graph.siblingRows || []).sort(function (a, b) { return a.x - b.x; });
    var isStartInMainSeriesData = checkAndSetStartInMainSeriesData(mainSeriesData, legends);
    updateLegendsForCancelledProjects(mainSeriesData, legends);
    var mainSeries = generateSeries(mainSeriesData, legends, 6);
    var drillDown = graph.mainDrillDown.map(function (drillDownSeries) {
        return processDrillDownSeries(drillDownSeries);
    });
    var mainLines = makeLine(mainSeriesData.map(function (row) { return [row.x, row.y]; }), '#C0C0C0', 4, isStartInMainSeriesData);
    var series = !isStartInMainSeriesData ?
        [makeStartPointSeries()].concat(mainSeries, mainLines) :
        mainSeries.concat(mainLines);
    if (siblingSeriesData.length > 0) {
        updateLegendsForCancelledProjects(siblingSeriesData, siblingLegends, true);
        var siblingSeries = generateSeries(siblingSeriesData, siblingLegends, 5);
        var siblingLines = makeLine(siblingSeriesData.map(function (row) { return [row.x, row.y]; }), '#e8c7b2', 3);
        series = series.concat(siblingSeries, siblingLines);
        drillDown = drillDown.concat(graph.siblingDrillDown.map(function (drillDownSeries) {
            return processDrillDownSeries(drillDownSeries);
        }));
    }
    return generateChartOptions(timestamp, chartTitle, settings, graph, nodeName, series, drillDown);
}
exports.getChartOptions = getChartOptions;
function getGroupByChartOptions(graph, options) {
    var currentNode = options.currentNode, chartTitle = options.chartTitle, _a = options.legends, legends = _a.legends, siblingLegends = _a.siblingLegends, settings = options.settings, timestamp = options.timestamp;
    var nodeName = currentNode.name;
    var series = [];
    var drillDownData = angular.copy(graph.mainDrillDown);
    drillDownData.forEach(function (data, index) {
        for (var _i = 0, _a = data['data']; _i < _a.length; _i++) {
            var point = _a[_i];
            if ('color' in data) {
                point['color'] = data['color'];
                point['colorTag'] = data['name'];
            }
        }
        var sortedData = data['data'].sort(function (a, b) { return a.x - b.x; });
        var groupByLegends = angular.copy(legends);
        if (!graph['isColorBy'] && graph['isGroupBy']) {
            groupByLegends[0]['tag'] = sortedData[sortedData.length - 1]['groupName'];
        }
        updateLegendsForCancelledProjects(sortedData, groupByLegends);
        var multiSelectSeries = generateSeries(sortedData, groupByLegends, 6, graph['isColorBy']);
        var dataColor = 'color' in data ? data['color'] : '#a9a9a9';
        var dashStyleIndex = index % basic_chart_component_1.getDashStyles().length;
        var multiSelectLines = makeLine(sortedData.map(function (row) { return [row.x, row.y]; }), basic_chart_component_1.lightenDarkenColor(dataColor, 40), 4, null, dashStyleIndex);
        series = series.concat(multiSelectSeries, multiSelectLines);
    });
    var siblingSeriesData = (graph.siblingRows || []).sort(function (a, b) { return a.x - b.x; });
    if (siblingSeriesData.length > 0) {
        updateLegendsForCancelledProjects(siblingSeriesData, siblingLegends, true);
        var siblingSeries = generateSeries(siblingSeriesData, siblingLegends, 5, graph['isColorBy']);
        var siblingLines = makeLine(siblingSeriesData.map(function (row) { return [row.x, row.y]; }), '#e8c7b2', 3);
        series = series.concat(siblingSeries, siblingLines);
    }
    return generateChartOptions(timestamp, chartTitle, settings, graph, nodeName, series);
}
exports.getGroupByChartOptions = getGroupByChartOptions;
function generateChartOptions(timestamp, chartTitle, settings, graph, nodeName, series, drillDown) {
    if (drillDown === void 0) { drillDown = null; }
    var ret = {
        chart: {
            renderTo: 'chartContainer',
            height: 560,
            width: 580,
            type: 'scatter',
            zoomType: 'xy',
            marginRight: 50
        },
        credits: {
            text: timestamp,
            href: null
        },
        title: {
            text: chartTitle
        },
        tooltip: {
            enabled: settings.showTooltip,
            formatter: function () {
                if (this.point.name && this.point.prodKey) {
                    return "<b>" + this.point.name + "</b> <i>(" + this.series.name + ")</i><br />" +
                        (graph.yTitle + ": <b>" + this.point.ay.toFixed(settings.decimals) + "</b><br />") +
                        (graph.xTitle + ": <b>" + this.point.ax.toFixed(settings.decimals) + "</b><br />") +
                        (graph.prodKey + ": <b>" + this.point.prodKey.toFixed(settings.decimals) + "</b>");
                }
                else {
                    return false;
                }
            },
            crosshairs: [true, true]
        },
        xAxis: {
            title: {
                enabled: true,
                text: graph.xTitle
            },
            startOnTick: true,
            endOnTick: true,
            showLastLabel: true,
            plotLines: [{
                    value: 0,
                    color: 'black',
                    width: 2,
                    zIndex: 1
                }]
        },
        yAxis: {
            title: {
                enabled: true,
                text: graph.yTitle
            },
            plotLines: [{
                    value: 0,
                    color: 'black',
                    width: 2,
                    zIndex: 1
                }]
        },
        plotOptions: {
            series: {
                turboThreshold: 0
            },
            scatter: {
                dataLabels: {
                    enabled: settings.showLabel,
                    style: {
                        fontWeight: 'thin'
                    },
                    formatter: function () {
                        if (!this.series.name || this.series.name.indexOf(":") !== -1) {
                            this.series.name = nodeName;
                        }
                        return this.point.name.slice(0, settings.charsInLabel);
                    }
                },
                marker: {
                    radius: 5,
                    symbol: 'circle',
                    states: {
                        hover: {
                            enabled: true,
                            lineColor: 'rgb(100,100,100)'
                        }
                    }
                },
                states: {
                    hover: {
                        marker: {
                            enabled: false
                        }
                    }
                }
            }
        },
        series: series
    };
    if (drillDown) {
        ret['drilldown'] = {
            activeAxisLabelStyle: {
                textDecoration: 'none',
                cursor: 'default',
                color: '#666666',
                'font-weight': 'normal',
                'pointer-events': 'none'
            },
            series: drillDown
        };
    }
    return ret;
}
//# sourceMappingURL=cfo-chart.chart.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/cfo-chart/cfo-chart.chart.js